const COMMON_EVENTS = {
	COPY_CODE: 153,
	OPEN_PAGE: 129,
	SEARCH: 194,
	ITEM_CLICKED: 199,
	SCROLL_TO_ANCHOR: 197,
	RUN_CODE: 221,
}

const FEATURE_FLOW_EVENTS = {
	STATUS_CHANGED: 196,
	TYPE_CHANGED: 217,
	SUBMIT_FEATURE: 218,
	ROADMAP_OPEN_CLOSE_COLLAPSABLE: 219,
	POST_COMMENT: 220,
}

const SHOWCASE_EVENTS = {
	BANNER_CLICKED: 212,
	LIGHTBOX_OPENED: 213,
	LIGHTBOX_SUBMITED: 214,
	LIGHTBOX_CLOSED_WITHOUT_SUBMITTING: 215
}

export const BI_EVENTS = Object.assign({}, COMMON_EVENTS, FEATURE_FLOW_EVENTS, SHOWCASE_EVENTS)

export const PAGE_PATH_TO_CATEGORY = {
	'hello-world': 'example',
	'events': 'velo_events',
	'event': 'velo_events',
	'wishlist': 'updates_and_release',
	'roadmap': 'updates_and_release',
	'request-a-feature-new': 'updates_and_release',
	'updates': 'updates_and_release',
	'updates-and-releases': 'updates_and_release',
	'requested-feature': 'updates_and_release',
	'showcase': 'showcase',
	'showcase-projects': 'showcase',
	'examples': 'example',
	'example': 'example',
	'video-tutorials': 'video_tutorial',
	'hire-a-developer': 'partners',
	'become-a-partner': 'partners',
	'forum': 'forum',
	'features': 'feature',
	'feature': 'feature',
	'all-documentation': 'documentation'
}